export default __webpack_public_path__ + "static/thumb-3-ab4131e3fb1500e04aaa576f12506e07.jpg";